import React, {useEffect} from 'react';
import {Col, Row, UiBox, UiDivider, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import clock from '~/assets/images/clock.svg';
import {AppDispatch} from '~/redux/root-store';
import {useDispatch, useSelector} from 'react-redux';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {useHistory} from 'react-router-dom';
import {PAGE_URLS} from '~/constants';
import welcome1 from '~/assets/images/welcome-1.png';
import {fetchTestimonials} from '~/redux/testimonials/thunk';
import {SOURCES_TESTIMONIAL} from '~/redux/testimonials/entity-config';

interface Props {}

const Questionnaire1Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder, collectedData} = mdq;
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.START);

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.START,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.START]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.HOW_IT_WORK}));
    history.push(PAGE_URLS.MDQ1_HOW_IT_WORKS);
  };

  useEffect(() => {
    dispatch(
      fetchTestimonials({
        source: SOURCES_TESTIMONIAL.TESTIMONIALS_PAGE,
      }),
    );
  }, [dispatch]);

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      handleOnNext={onClickSubmit}
      showBackButton={false}
      pageTitle={questionnaire?.title}
      isFirstScreen
    >
      <Col alignItems="center" textAlign="center" mt={12} mb={1}>
        <Row mb={5}>
          {/* {questionnaire?.careTeam?.images.map((url, index) => (
            <UiImage key={index} boxSize={20} url={url} borderRadius={1.5} mx={2} />
          ))} */}
          <UiImage url={welcome1} height={100} borderRadius={1.5} mx={2} />
        </Row>
        <Col>
          <UiText fontWeight="bold" mb={1}>
            {questionnaire?.careTeam?.title}
          </UiText>
          <UiText textAlign="center" fontSize="xs" maxW={48}>
            {questionnaire?.careTeam?.description}
          </UiText>
        </Col>
        <UiDivider color="black" my={12} px={1} />
        <Col mb={8} mt={3}>
          <UiText fontSize="2xl" fontWeight="bold" mb={4}>
            {questionnaire?.questions?.default}
          </UiText>
          <UiText textAlign="center" fontSize="xs" maxW={72}>
            {questionnaire?.questions?.description}
          </UiText>
        </Col>
        <Row alignItems="center" justifyContent="center">
          <UiImage boxSize="0.9375rem" url={clock} />
          <UiText fontWeight="bold" fontSize="xs" px={3}>
            {questionnaire?.questions?.estimateTime}
          </UiText>
        </Row>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire1Screen;
